import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { map, catchError } from 'rxjs/operators';

import { AuthService } from '@app/services';
import { SessionService } from '@app/session/session.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationIssueModuleGuard {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly sessionService: SessionService,
  ) {}

  canActivate = () => {
    return this.authService.checkSession().pipe(
      map((authRes) => {
        return !!authRes.error || !!this.router.getCurrentNavigation().extractedUrl.queryParams['error'];
      }),
      catchError(() => of(true)),
    );
  };

  canLoad = () => {
    return this.authService.checkSession().pipe(
      map((authRes) => {
        return !!authRes.error || !!this.router.getCurrentNavigation().extractedUrl.queryParams['error'];
      }),
      catchError(() => of(true)),
    );
  };

  canDeactivate = () => this.sessionService.leaveDomain().pipe(map(() => true));
}
